module.exports = __webpack_public_path__ + "media/customizations/christensoncommunities/logo-e4bb702107ee324257d8052bb8601623.png";